type TelegramUser = {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  language_code?: string;
  is_premium?: boolean;
};

type InitDataUnsafe = {
  user?: TelegramUser;
  [key: string]: unknown;
};

export const useTelegram = () => {
  const tg = window.Telegram?.WebApp;

  const initDataUnsafe = tg?.initDataUnsafe as InitDataUnsafe;

  return {
    tg,
    initData: tg?.initData ?? "",
    initDataUnsafe,
    user: initDataUnsafe?.user,
  };
};
